import React from 'react';
import { Button } from '../../../../../components/MuiGenerals';
import { useTranslation } from '../../../../../hooks';

interface IProps {
  onClick: () => void;
  isExpanded: boolean;
}

const ShowMoreButton = ({ onClick, isExpanded }: IProps) => {
  const { tc } = useTranslation();

  return (
    <Button
      variant="text"
      size="small"
      onClick={onClick}
      style={{ alignSelf: 'flex-start', padding: 0, minWidth: 'unset' }}
    >
      <span style={{ fontSize: '10px', color: '#4AA3FF' }}>
        {isExpanded ? tc('showLess') : tc('showMore')}
      </span>
    </Button>
  );
};

export default ShowMoreButton;
